import { render, staticRenderFns } from "./ViewersBar.vue?vue&type=template&id=13d876ba&scoped=true&"
import script from "./ViewersBar.vue?vue&type=script&lang=js&"
export * from "./ViewersBar.vue?vue&type=script&lang=js&"
import style0 from "./ViewersBar.vue?vue&type=style&index=0&id=13d876ba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d876ba",
  null
  
)

export default component.exports